import axios from 'axios'
import Cookies from 'js-cookie'
let util = {}
const ajaxUrl = '/api'

util.ajax = axios.create({
  baseURL: ajaxUrl,
  timeout: 600000,
  withCredentials: true,
  crossDomain: true
})

util.ajax.interceptors.request.use(config => {
  if (config.url.indexOf('/webLogin') === -1 && config.url.indexOf('/hz/captcha.jpg') === -1) {
    config.headers['token'] = Cookies.get('tokenEshopManager')
  }
  return config
})
util.ajax.interceptors.response.use(data => {

  var returnData
  if (typeof data === 'object') {
    returnData = data
  } else {
    returnData = JSON.parse(data)
  }

  if (returnData.data.code === 401 || returnData.data.code === 7) {
    alert('登录已失效,请重新登录')
    Cookies.set('tokenEshopManager', '')
    localStorage.removeItem('router')
    Cookies.set('menus_state', '')
    Cookies.set('password', '')
    Cookies.set('user', '')
    window.location.href = '/login'
    return Promise.reject(returnData)
  } else {
    return returnData
  }
})
util.recursion = (value) => {
  let arr = []

  value.forEach((item) => {
    if (item.router_display !== -1) {
      arr.push(item)
    }
    let children = null
    if (item.children.length > 0) {
      children = util.recursion(item.children)
      if (children.length > 0) {
        children.forEach(child => {
          if (child.router_display !== -1) {
            arr.push(child)
          }
        })
      }
    }
  })
  return arr
}
util.AddRouter = (value, vm) => {
  let arr = util.recursion(value)
  let List = []
  arr.forEach(item => {
    if (!item.component) return true
    List.push({
      title: item.title,
      name: item.name,
      path: '/' + item.name,
      meta: item.meta, // catalog routerCatalog_add
      component: () => import('@/view/' + item.component + '.vue')
    })
  })
  vm.$store.commit('routerCatalog_add', List)
}

util.infoRouter = (data, vm) => {
  let arr = []
  if (data && data !== undefined) {
    arr = data
  } else {
    let str = localStorage.getItem('router') ? localStorage.getItem('router') : []
    if (str.length > 0) {
      arr = JSON.parse(str)
    } else {
      arr = []
    }
  }
  util.AddRouter(arr, vm)
}
util.uploadPhoto = (file, mv) => {
  let form = new FormData()
  form.append('uploadFiles', file)
  return new Promise((resolve, reject) => {
    util.ajax.post('/app/consulting/consultationPicture', form).then(res => {
      if (res.data.code === 0) {
        mv.$notify.success({title: '成功', message: '图片上传成功'})
        resolve(res.data)
      } else mv.$notify.warning({title: '警告', message: res.data})
    }).catch((e) => {
      console.log(e, '/app/consulting/consultationPicture')
      mv.$notify.error({title: '错误', message: '接口访问失败,请与系统管理员联系'})
      reject(e)
    })
  })
}

export default util



// WEBPACK FOOTER //
// ./src/util/util.js